import { load } from 'cheerio';
import { listPropsInjectorFactory } from './inject-missing-list-props';
import { defaultContainerMissingPropsInjectorFactory, explicitInheritanceFactory, } from './inject-missing-props-into-default-containers';
import { postProcessHtmlFactory } from './post-process-html';
import { linkStyleInjectorFactory } from './inject-missing-link-style';
import { transformElement } from './transform-element';
export const injectMissingPropsIntoHtml = (html, props, composerData, css, experiments, useChildrenHtml = false) => {
    const injectorFactories = [
        explicitInheritanceFactory,
        defaultContainerMissingPropsInjectorFactory,
        listPropsInjectorFactory,
        postProcessHtmlFactory,
        linkStyleInjectorFactory,
    ];
    const injectors = injectorFactories.map((factory) => factory({ html, props, composerData, experiments }));
    const cheerioResult = injectors.reduce((finalOutput, injector) => {
        return injector.elements.reduce((injectorOutput, element) => {
            return transformElement(element)(injectorOutput, { ...props, css }, injector.mutators);
        }, finalOutput);
    }, load(html));
    let result = useChildrenHtml
        ? cheerioResult('body').children().html()
        : cheerioResult('body').html();
    result = result.replace(/\n/g, '<br />');
    return result;
};
//# sourceMappingURL=inject-missing-props-into-html.js.map